import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setOddsFormat } from "../../../../../../../../../../../store/action/settings/setoddsformat";
import "./OddsformatSelect.scss";

interface IOddsformatSelect {
  oddsFormat: string;
  setSettings: React.Dispatch<React.SetStateAction<boolean>>;
}

const OddsformatSelect = ({ oddsFormat, setSettings }: IOddsformatSelect) => {
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);

  const handleItemSelect = (item: string) => {
    dispatch(setOddsFormat(item));
    setSettings(false);
  };

  const handleOpenModal = () => {
    setModalOpen((prev) => !prev);
  };
  const handleClosePanel = () => {
    setModalOpen(false);
  };

  const handleTapOutside = (event: MouseEvent | TouchEvent) => {
    if (
      wrapperRef.current &&
      !(wrapperRef.current as HTMLElement).contains(event.target as Node)
    ) {
      handleClosePanel();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleTapOutside);
    document.addEventListener("touchstart", handleTapOutside);
    return () => {
      document.removeEventListener("mousedown", handleTapOutside);
      document.removeEventListener("touchstart", handleTapOutside);
    };
  }, []);
  return (
    <div
      className="form-control-bc select  filled"
      tabIndex={0}
      ref={wrapperRef}
    >
      <div
        className="form-control-label-bc form-control-select-bc inputs "
        onClick={handleOpenModal}
      >
        <span className="ellipsis">{oddsFormat}</span>
        <i
          className={`form-control-icon-bc bc-i-small-arrow-${
            modalOpen ? "up" : "down"
          }`}
        />
        <i className="form-control-input-stroke-bc" />
        <span className="form-control-title-bc ellipsis">
          {t("admin.OddsFormat")}
        </span>
      </div>
      {modalOpen ? (
        <div className="multi-select-label-bc" data-scroll-lock-scrollable="">
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "Decimal" ? "active" : ""
            } `}
            data-option-value={0}
            onClick={() => handleItemSelect("Decimal")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.Decimal")}
            </p>
          </label>
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "Fractional" ? "active" : ""
            } `}
            data-option-value={1}
            onClick={() => handleItemSelect("Fractional")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.Fractional")}
            </p>
          </label>
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "American" ? "active" : ""
            } `}
            data-option-value={2}
            onClick={() => handleItemSelect("American")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.American")}
            </p>
          </label>
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "HongKong" ? "active" : ""
            } `}
            data-option-value={3}
            onClick={() => handleItemSelect("HongKong")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.HongKong")}
            </p>
          </label>
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "Malay" ? "active" : ""
            } `}
            data-option-value={4}
            onClick={() => handleItemSelect("Malay")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.Malay")}
            </p>
          </label>
          <label
            className={`checkbox-control-content-bc ${
              oddsFormat === "Indo" ? "active" : ""
            } `}
            data-option-value={5}
            onClick={() => handleItemSelect("Indo")}
          >
            <p
              className="checkbox-control-text-bc"
              style={{ pointerEvents: "none" }}
            >
              {t("admin.Indo")}
            </p>
          </label>
        </div>
      ) : null}
    </div>
  );
};

export { OddsformatSelect };
